import { Injectable } from "@angular/core";
import { MyContentsService } from "@app/services/system/my-contents.service";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError} from 'rxjs/operators';

import * as myContentsAction from "src/app/actions/system/my-contents.actions";

@Injectable()
export class MyContentsEffect {
    constructor(
        private _actions$: Actions,
        private myContentsService: MyContentsService
      ) { }

    loadContents$ = createEffect(() => this._actions$.pipe(
        ofType(myContentsAction.loadContents),
        switchMap(() => this.myContentsService.getContents().pipe(
            map((res) => myContentsAction.loadContentsSuccess({ contents: res })),
            catchError((err) => of(myContentsAction.loadContentsFailure({ msg: err })))
        ))
    ));
}
